import React from 'react'
import Col from 'react-bootstrap/Col';


export default function Header({title,businessName}) {
  return (
    <>
      <header className="header mb-4 text-md-start text-center">
        <h1>{title}</h1>
        <strong>Payment Detail</strong>
        <Col className="header-merchant-name d-md-none">
          <strong>{businessName}</strong>
        </Col>
      </header>
    </>
  )
}
